/*
 * Custom error message component
 * <p>
 *
 * @author Dzhenko Zlatev
 * @author Gallagher Bassett IT
 * @author Copyright (c) 2020 Gallagher Bassett Services, Inc.
 *
 */
import {
  AfterViewInit,
  Component,
  Input
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'reporter-error-modal',
    templateUrl: './error-modal.component.html',
    styleUrls: ['./error-modal.component.scss'],
    standalone: false
})
export class ErrorModalComponent implements AfterViewInit {

  @Input() public title = 'An error occurred';
  @Input() public message = '';
  @Input() public violations: any[] = [];

  public show = false;
  public isCollapsed = true;

  constructor(public activeModal: NgbActiveModal) {
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.show = true;
    });
  }

  public close() {
    this.activeModal.dismiss();
  }
}
